<template>
    <section class="formPage">
        <h2>{{ $store.getters.getFormData.formTitle }}</h2>
        <form>
            <div class="formList">
                <h3 class="itemTitle">
                    {{ $store.getters.getFormData.reportList.listTitle }}
                </h3>
                <FormList
                    v-for="report in $store.getters.getFormData.reportList
                        .checkItem"
                    :key="report.id"
                    :listData="report"
                    @listTarget="saveReportName"
                ></FormList>
            </div>
            <div class="notice" v-if="$store.getters.getFormData.notice.title">
                <p class="notice__title">
                    {{ $store.getters.getFormData.notice.title }}
                </p>
                <div class="notice__content">
                    <p
                        class="noticeList"
                        v-for="(notice, index) in $store.getters.getFormData
                            .notice.list"
                        :key="index"
                    >
                        {{ `${index + 1}. ${notice.content}` }}
                        <a
                            v-if="notice.mailLink"
                            class="mailLink"
                            :href="`mailto:${notice.mailLink}`"
                            >{{ notice.mailLink }}</a
                        >
                    </p>
                </div>
            </div>
            <!-- <div class="formList">
                <h3 class="itemTitle">
                    {{ $store.getters.getFormData.relationList.listTitle }}
                </h3>
                <FormList
                    v-for="report in $store.getters.getFormData.relationList
                        .checkItem"
                    :key="report.id"
                    :listData="report"
                    @listTarget="
                        ckeckedData = {
                            ...ckeckedData,
                            relationship: $event,
                        }
                    "
                ></FormList>
            </div>
            <div class="formList">
                <h3 class="itemTitle">
                    {{ $store.getters.getFormData.ageList.listTitle }}
                </h3>
                <FormList
                    v-for="report in $store.getters.getFormData.ageList
                        .checkItem"
                    :key="report.id"
                    :listData="report"
                    @listTarget="
                        ckeckedData = {
                            ...ckeckedData,
                            age: $event,
                        }
                    "
                ></FormList>
            </div>
            <div class="formList">
                <h3 class="itemTitle">
                    {{ $store.getters.getFormData.concernList.listTitle }}
                </h3>
                <div
                    class="concernList"
                    v-for="checkItem in $store.getters.getFormData.concernList
                        .checkItem"
                    :key="checkItem.id"
                >
                    <span class="concernList__title">{{
                        checkItem.itemTitle
                    }}</span>
                    <div class="concernList__area">
                        <FormList
                            v-for="report in checkItem.checklist"
                            :key="report.id"
                            :listData="report"
                            @listTarget="
                                ckeckedData = {
                                    ...ckeckedData,
                                    [report.group]: $event,
                                }
                            "
                        ></FormList>
                    </div>
                </div>
            </div>
            <div class="formList topic">
                <h3 class="topic__Title itemTitle">
                    {{ $store.getters.getFormData.materiality.listTitle }}
                </h3>
                <input
                    class="topic__typeTopic"
                    :value="ckeckedData.other"
                    @input="
                        ckeckedData = {
                            ...ckeckedData,
                            other: $event.target.value,
                        }
                    "
                    type="text"
                />
            </div> -->
            <div class="formList authen">
                <h3 class="authen__Title itemTitle">
                    {{ $store.getters.getFormData.auth.listTitle }}
                </h3>
                <figure class="authen__img">
                    <img :src="$store.getters.getCaptcha.img" alt="" />
                </figure>
                <input
                    class="authen__typeTopic"
                    :value="authData.captcha"
                    @input="
                        authData = {
                            ...authData,
                            captcha: $event.target.value,
                            key: $store.getters.getCaptcha.key,
                        }
                    "
                    type="text"
                />
            </div>
        </form>
        <div class="button">
            <button class="button__style" @click="submitFormData">
                Submit and Download Report
            </button>
            <button
                :disabled="noAuthData"
                class="button__style"
                :class="{
                    'button__style--disabled': noAuthData,
                }"
                @click="resetForm"
            >
                Reset
            </button>
        </div>
        <div
            v-if="$store.getters.getFormData.googleFormLink.link"
            class="googleForm"
        >
            <p class="googleForm__title">
                {{ $store.getters.getFormData.googleFormLink.title }}
            </p>
            <span class="googleForm__text">{{
                $store.getters.getFormData.googleFormLink.text
            }}</span>
            <div class="googleForm__linkArea">
                <a
                    class="formLink"
                    target="_blank"
                    :href="$store.getters.getFormData.googleFormLink.link"
                    >{{
                        $store.getters.getFormData.googleFormLink.linkTitle
                    }}</a
                >
            </div>
        </div>
    </section>
</template>

<script>
import FormList from "@/components/FormList";
export default {
    components: {
        FormList,
    },
    beforeRouteEnter(to, from, next) {
        document.title = to.meta.title;
        next(async (vm) => {
            await vm.$store.dispatch("fetchKv", {
                content: "form",
                lang: to.params.lang,
            });
            await vm.$store.dispatch("fetchCaptcha");
        });
    },
    async beforeRouteUpdate(to, from, next) {
        // document.title = to.meta.title;
        await this.$store.dispatch("fetchMenu", {
            lang: to.params.lang,
        });
        await this.$store.dispatch("fetchKv", {
            content: "form",
            lang: to.params.lang,
        });
        await this.$store.dispatch("fetchCaptcha");
        next();
    },
    data() {
        return {
            ckeckedData: {
                // other: "",
            },
            // ckeckedData: {
            //     other: "",
            // },
            authData: {},
        };
    },
    methods: {
        async submitFormData() {
            const checkAuthData = Object.keys(this.authData).length >= 2;
            if (!checkAuthData) return this.verificationWarning();
            if (!this.requiredItems) return this.requiredWarning();

            this.ckeckedData = { ...this.ckeckedData, is_tw: this.countryCode };

            await this.$store.dispatch("postFormList", {
                survey: this.ckeckedData,
                authData: this.authData,
            });
            const failMessage = this.$store.getters.getFormListResult;
            if (failMessage === "invalidCaptcha")
                return this.verificationWarning();
            if (failMessage === "noSurvey") return this.requiredWarning();

            const downLink = "/api/get/download";
            this.createDownLink(downLink, this.ckeckedData.report);
            this.resetForm();
        },
        fetchCaptcha() {
            this.authData = {};
            this.$store.dispatch("fetchCaptcha");
        },
        resetForm() {
            this.fetchCaptcha();
            this.ckeckedData = { other: "" };
            this.authData = {};
            const [...checkMarks] = document.querySelectorAll(".checkMark");
            checkMarks.forEach((checkMark) => {
                checkMark.checked = false;
            });
        },
        saveReportName(event) {
            this.ckeckedData = {
                ...this.ckeckedData,
                report: event,
            };
        },
        checkAuthResult(resultMessage) {
            if (resultMessage === "ok") {
                alert("Authentication is ok");
            } else {
                alert("check the Authentication Code");
                this.fetchCaptcha();
            }
        },
        requiredWarning() {
            this.fetchCaptcha();
            if (this.currentLang === "global") {
                return alert("Please check the Report items");
            } else {
                return alert("請確認報告選項");
            }
        },
        verificationWarning() {
            this.fetchCaptcha();
            if (this.currentLang === "global") {
                return alert("Please check the Authentication Code");
            } else {
                return alert("請確認驗證碼");
            }
        },
        createDownLink(currentLink, fileName) {
            const downLink = document.createElement("a");
            downLink.href = currentLink;
            downLink.download = fileName;
            downLink.click();
            downLink.remove();
        },
    },
    computed: {
        noAuthData() {
            // const numberOfOption = 1;
            // const currentData =
            //     Object.keys(this.ckeckedData).length > numberOfOption;
            // const formOther = this.ckeckedData.other;
            const authData = Object.keys(this.authData).length;
            // return !currentData && !formOther && !authData;
            return !authData;
        },
        requiredItems() {
            const numberOfCheckData = Object.keys(this.ckeckedData).length;
            return numberOfCheckData >= this.requiredLength;
        },
        requiredLength() {
            const numberOfReport = 1;
            // const numberOfAge = 1;
            // const numberOfrelation = 1;
            // const numberOfConcernList = Object.keys(
            //     this.$store.getters.getFormData.concernList.checkItem
            // ).length;
            // //必填資料長度
            // const totalLength =
            //     numberOfReport +
            //     numberOfAge +
            //     numberOfrelation +
            //     numberOfConcernList;
            // return totalLength;

            return numberOfReport;
        },
        currentLang() {
            return this.$store.getters.getCurrentLang;
        },
        countryCode() {
            const isGlobal = this.$store.getters.getCurrentLang === "global";
            return isGlobal ? 0 : 1;
        },
    },
};
</script>

<style lang="sass" scoped>
.formPage
    width: 80%
    margin: 0 auto
    text-align: center
    min-height: 100vh
    @media (min-width:960px)
        width: 70%
form
    text-align: left
.itemTitle
    margin-top: 12px
    margin-bottom: 4px
    font-size: 18px
.formList
    background-color: #fcfcfc
    box-shadow: 2px 2px 10px #d4d4d4
    padding: 10px 15px
    border-radius: 5px
    margin-top: 35px

.notice
    color: red
    font-size: 14px
    margin-top: 10px
    padding: 0 25px
    .noticeList
        margin-top: 5px


.concernList
    border-bottom: 1px solid #d6d6d6
    padding: 10px
    &:nth-last-child(1)
        border-bottom: none

    @media (min-width:540px)
        display: flex
        justify-content: space-between
        align-items: center
    &__area
        display: flex
        margin-top: 5px
        ::v-deep(.listText)
            margin-left: 10px
        @media (min-width:540px)
            margin-top: 0

.topic
    &__typeTopic
        width: 90%
        margin: 15px 0
        padding: 5px 3px
.authen
    &__button
        margin-left: 10px
    &__img
        width: 35%
        margin-top: 10px
        img
            width: 100%

    &__typeTopic
        width: 35%
        margin: 10px 0
        padding: 5px 3px
.button
    margin-top: 35px
    button+button
        margin-left: 15px
        margin-top: 10px
        @media (min-width:380px)
            margin-top: 0
    &__style
        color: #4a423a
        padding: 5px 10px
        border: 1px solid #4a423a
        background-color: transparent
        transition: background-color 0.2S ease-in-out
        cursor: pointer
        &:hover
            background-color: #4a423a
            color: #fff
        &--disabled
            color: #fff
            background-color: lightgrey
            cursor: not-allowed
            &:hover
                background-color: lightgrey
.googleForm
    margin-top: 100px
    &__title
        color: #111111
        font-size: 21px
        font-weight: bold
        margin-bottom: 14px
    &__text
        color: #707070
        font-size: 16px
    &__linkArea
        width: 274px
        margin: 27px auto 0
        border: 1px solid #707070
        transition: background-color 0.2S ease-in-out
        .formLink
            width: 274px
            display: inline-block
            color: #7A7A7A
            font-size: 23px
            text-decoration: none
            padding: 8px 0

        &:hover
            background-color: #4a423a
            .formLink
                color: #fff
</style>
